import { render, staticRenderFns } from "./CtrIntegration.vue?vue&type=template&id=326bacd7&"
import script from "./CtrIntegration.vue?vue&type=script&lang=ts&"
export * from "./CtrIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/ManageAccount.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Fadministration%2FCtrIntegration.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports